import React, { useState, forwardRef, useImperativeHandle } from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import CloseIcon from '@material-ui/icons/Close';
import Rating from '@material-ui/lab/Rating';
import { useSnackbar } from 'notistack';

import {
  TextInput,
  PrecoInput,
  AutoCompleteRemoto,
  DateInputBonito,
} from '../../../Components';
import { createAPI, updateAPI, getListAllAPI } from '../../../services';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    // color: theme.palette.grey[500],
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const DEFAULT_ID = -1;

const DialogoCategoriaTransacao = forwardRef(({ handleClose }, ref) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [descricao, setDescricao] = useState('');
  const [valor, setValor] = useState(0);
  const [data, setData] = useState(new Date());
  const [user, setUser] = useState(null);
  const [categoria, setCategoria] = useState(null);
  const [id, setId] = useState(DEFAULT_ID);

  const [carregando, setCarregando] = useState(false);

  const classes = useStyles({ cor: '#009FD4' });

  const handleCloseDialog = () => {
    setOpen(false);
    handleClose();
  };

  async function reiniciar() {
    setId(DEFAULT_ID);
    setDescricao('');
    setValor(0);
    setData(new Date());
    setUser(null);
    setCategoria(null);
    setCarregando(false);
  }

  async function getDataResource(id) {
    try {
      const data = await getListAllAPI(
        'descontos_funcionarios',
        ['id', 'asc'],
        { id: [id] },
        ['user', 'categoria'],
      );
      if (data.data.length > 0) {
        setId(data.data[0].id);
        setDescricao(data.data[0].descricao);
        setValor(data.data[0].valor);
        setData(data.data[0].data);
        setUser(data.data[0].user);
        setCategoria(data.data[0].categoria);
        setCarregando(false);
      } else {
        throw 'Este Desconto de funcionário não existe!';
      }
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  async function handleSalvar() {
    setCarregando(true);
    try {
      if (id <= 0) {
        await createAPI('descontos_funcionarios', {
          descricao,
          valor,
          data,
          user_id: user.id,
          categoria_desconto_funcionario_id: categoria.id,
        });
        setCarregando(false);
        enqueueSnackbar('Desconto de funcionário criado com sucesso!', {
          variant: 'success',
        });
      } else {
        await updateAPI('descontos_funcionarios', id, {
          descricao,
          valor,
          data,
          user_id: user.id,
          categoria_desconto_funcionario_id: categoria.id,
        });
        setCarregando(false);
        enqueueSnackbar('Desconto de funcionário atualizado com sucesso!', {
          variant: 'success',
        });
      }

      handleCloseDialog();
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  useImperativeHandle(ref, () => ({
    handleCreate() {
      reiniciar();
      setOpen(true);
    },
    handleEdit(id) {
      setCarregando(true);
      getDataResource(id);
      setId(id);
      setOpen(true);
    },
  }));

  function validateDescricao() {
    let error = '';
    if (descricao) {
      if (descricao.length > 300) {
        error = 'Número de caracteres maior que o permitido (máximo 80)';
      }
    }
    return error;
  }

  function validateValor() {
    let error = '';
    if (valor <= 0 || Number.isNaN(valor)) {
      error = 'Este campo é obrigatório';
    }
    return error;
  }

  function validateUser() {
    let error = '';
    if (!user) {
      error = 'Este campo é obrigatório';
    }
    return error;
  }

  function validateCategoria() {
    let error = '';
    if (!categoria) {
      error = 'Este campo é obrigatório';
    }
    return error;
  }

  function getErros() {
    const errosOld = [''];
    errosOld[0] = validateDescricao();
    errosOld[1] = validateValor();
    errosOld[2] = validateUser();
    errosOld[3] = validateCategoria();
    return errosOld;
  }

  const erros = getErros();

  function hasError() {
    for (let i = 0; i < erros.length; i += 1) {
      if (erros[i] !== '') return true;
    }
    return false;
  }

  const erroExistente = hasError();

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        classes={{ paper: classes.rootDialogo }}
        className={classes.rootDialogo}
        fullWidth
        maxWidth="sm"
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle
          id="form-dialog-title"
          onClose={handleCloseDialog}
          style={{ backgroundColor: '#009FD4', color: 'white' }}
        >
          {id < 0
            ? `Novo Desconto de funcionário`
            : `Editar Desconto de funcionário`}
        </DialogTitle>
        <DialogContent
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          {carregando ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div>
              <Box flex={1} mr="0.5em">
                <AutoCompleteRemoto
                  name=""
                  handleEnter={() => {}}
                  label="Categoria"
                  handleKey={() => {}}
                  value={categoria}
                  onChange={(value) => setCategoria(value)}
                  error={erros[3] !== ''}
                  helperText={erros[3]}
                  fullWidth
                  toString={false}
                  getOptionSelected={(option, value) =>
                    option.nome === value.nome
                  }
                  getOptionLabel={(option) => `${option.nome}`}
                  nested={[]}
                  filters={{}}
                  autoFocus
                  resource="categorias_descontos_funcionarios"
                />
              </Box>
              <Box flex={1} mr="0.5em">
                <AutoCompleteRemoto
                  name="user"
                  handleEnter={() => {}}
                  label="Funcionário"
                  handleKey={() => {}}
                  value={user}
                  onChange={(value) => setUser(value)}
                  error={erros[2] !== ''}
                  helperText={erros[2]}
                  fullWidth
                  toString={false}
                  getOptionSelected={(option, value) =>
                    option.username === value.username
                  }
                  getOptionLabel={(option) => `${option.username}`}
                  nested={[]}
                  filters={{}}
                  resource="users"
                  campo="username"
                />
              </Box>

              <Box flex={1} mr="0.5em">
                <PrecoInput
                  name="valor"
                  handleEnter={() => {}}
                  label="Valor"
                  handleKey={() => {}}
                  value={Number.isNaN(valor) ? '' : String(valor)}
                  onChange={(value) => setValor(parseFloat(value.target.value))}
                  error={erros[1] !== ''}
                  helperText={erros[1]}
                  fullWidth
                />
              </Box>
              <Box flex={1} mr="0.5em">
                <DateInputBonito
                  showTodayButton
                  disableFuture
                  todayLabel="Hoje"
                  name="data_pagamento"
                  handleEnter={() => {}}
                  label="Data"
                  handleKey={() => {}}
                  value={data}
                  onChange={(value) => {
                    setData(value);
                  }}
                  format="dd MMMM yyyy"
                  fullWidth
                  inputVariant="outlined"
                />
              </Box>
              <Box flex={1} mr="0.5em">
                <TextInput
                  name="nome"
                  handleEnter={() => {}}
                  label="Descrição"
                  handleKey={() => {}}
                  value={descricao}
                  onChange={(value) => setDescricao(value.target.value)}
                  error={erros[0] !== ''}
                  helperText={erros[0]}
                  fullWidth
                  variant="outlined"
                />
              </Box>
            </div>
          )}
        </DialogContent>
        <DialogActions
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          <div className={classes.wrapper}>
            <Button
              onClick={handleSalvar}
              classes={{
                root: classes.btnAtions,
                disabled: classes.btnAtionsDisabled,
              }}
              disabled={erroExistente || carregando}
              variant="contained"
              color="primary"
            >
              Salvar
            </Button>
            {carregando && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default DialogoCategoriaTransacao;
